import {
  CREATE_SHIPPING_CHARGE_FAILURE,
  CREATE_SHIPPING_CHARGE_REQUEST,
  GET_ALL_SHIPPING_CHARGE_REQUEST,
  GET_ALL_SHIPPING_CHARGE_SUCCESS,
  GET_ALL_SHIPPING_CHARGE_FAILURE,
  DELETE_SHIPPING_CHARGE_REQUEST,
  DELETE_SHIPPING_CHARGE_FAILURE,
  UPDATE_SHIPPING_CHARGE_REQUEST,
  UPDATE_SHIPPING_CHARGE_FAILURE,
  DELETE_SHIPPING_CHARGE_SUCCESS,
} from "./ActionType";

const initialState = {
  shippingCharges: [],
  loading: false,
  error: "",
};

export const shippingChargeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SHIPPING_CHARGE_REQUEST:
      return { ...state, loading: true };

    case CREATE_SHIPPING_CHARGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_SHIPPING_CHARGE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_SHIPPING_CHARGE_SUCCESS:
      return { ...state, loading: false, error: "", shippingCharges: action.payload };

    case GET_ALL_SHIPPING_CHARGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SHIPPING_CHARGE_REQUEST:
      return { ...state, loading: true };

    case DELETE_SHIPPING_CHARGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        shippingCharges: state.shippingCharges?.response?.filter(sc => sc.id !== action.payload)  // Remove deleted category
      };

    case DELETE_SHIPPING_CHARGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SHIPPING_CHARGE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_SHIPPING_CHARGE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
